import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=c58c54b6&scoped=true&"
import script from "./CaseList.vue?vue&type=script&lang=ts&"
export * from "./CaseList.vue?vue&type=script&lang=ts&"
import style0 from "./CaseList.vue?vue&type=style&index=0&id=c58c54b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58c54b6",
  null
  
)

export default component.exports